import { Controller } from "@hotwired/stimulus"

// Controller for media preview modal with image display and metadata
export default class extends Controller {
  static targets = ["modal", "image", "imageContainer", "filename", "size", "type", "uploaded", "dimensions", "dimensionsContainer", "downloadLink", "deleteButton"]

  connect() {
    this.handleEscape = this.handleEscape.bind(this)
  }

  open(event) {
    event.preventDefault()

    // Get data from the clicked element
    const element = event.currentTarget
    const imageUrl = element.dataset.mediaPreviewUrl
    const thumbnailUrl = element.dataset.mediaPreviewThumbnail || imageUrl
    const filename = element.dataset.mediaPreviewFilename
    const size = element.dataset.mediaPreviewSize
    const contentType = element.dataset.mediaPreviewType
    const uploadedDate = element.dataset.mediaPreviewUploaded
    const dimensions = element.dataset.mediaPreviewDimensions
    const downloadUrl = element.dataset.mediaPreviewDownload
    const deleteUrl = element.dataset.mediaPreviewDelete

    if (!imageUrl) return

    // Set modal content
    this.imageTarget.src = thumbnailUrl
    this.imageTarget.onload = () => {
      // Once thumbnail loads, load full image
      if (imageUrl !== thumbnailUrl) {
        const fullImage = new Image()
        fullImage.onload = () => {
          this.imageTarget.src = imageUrl
        }
        fullImage.src = imageUrl
      }
    }

    this.filenameTarget.textContent = filename || 'Unknown'
    this.sizeTarget.textContent = size || 'Unknown'
    this.typeTarget.textContent = contentType || 'Unknown'
    this.uploadedTarget.textContent = uploadedDate || 'Unknown'

    if (dimensions) {
      this.dimensionsTarget.textContent = dimensions
      this.dimensionsContainerTarget.classList.remove('hidden')
    } else {
      this.dimensionsContainerTarget.classList.add('hidden')
    }

    if (downloadUrl) {
      this.downloadLinkTarget.href = downloadUrl
      this.downloadLinkTarget.classList.remove('hidden')
    } else {
      this.downloadLinkTarget.classList.add('hidden')
    }

    if (deleteUrl) {
      this.deleteButtonTarget.dataset.mediaPreviewDeleteUrl = deleteUrl
      this.deleteButtonTarget.classList.remove('hidden')
    } else {
      this.deleteButtonTarget.classList.add('hidden')
    }

    // Show modal
    this.modalTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'

    // Add escape key listener
    document.addEventListener('keydown', this.handleEscape)
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }

    this.modalTarget.classList.add('hidden')
    document.body.style.overflow = ''

    // Clear image src to stop loading
    this.imageTarget.src = ''

    // Remove escape key listener
    document.removeEventListener('keydown', this.handleEscape)
  }

  handleEscape(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      this.close()
    }
  }

  confirmDelete(event) {
    event.preventDefault()

    const deleteUrl = event.currentTarget.dataset.mediaPreviewDeleteUrl

    if (!deleteUrl) return

    if (confirm('Are you sure you want to delete this file? This action cannot be undone.')) {
      // Create a form and submit it with Turbo
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = deleteUrl
      form.dataset.turboMethod = 'delete'

      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
      if (csrfToken) {
        const csrfInput = document.createElement('input')
        csrfInput.type = 'hidden'
        csrfInput.name = 'authenticity_token'
        csrfInput.value = csrfToken
        form.appendChild(csrfInput)
      }

      document.body.appendChild(form)
      form.requestSubmit()

      // Close modal
      this.close()
    }
  }

  disconnect() {
    // Cleanup
    document.removeEventListener('keydown', this.handleEscape)
    document.body.style.overflow = ''
  }
}